export default {
  label: "Einstellungen",
};
